export default {
  label: "Einstellungen",
};
